<app-navbar></app-navbar>

<section class="mbody" style="margin-top: 20px; margin-bottom: 20px;">
    <div class="container">
        <div class="row">
            <div class="col-md-6 mbody-img-margin" style='text-align: justify;'>
                <h3 style="color: white;">Success of Proyash-Chattogram in Introducing Special Education</h3>

                <p style="color: white;" >Proyash-Chattogram is the pioneer institute to introduce special educational structure in Chattogram as well as
                Bangladesh. It has imparted training to children with special needs to develop day to day efficiency. The organization
                has made outstanding endeavors to bring forth a relevant context of special education to mainstream education.
                Proyash-Chattogram has adopted programs to organize the classes of children of different ages in accordance with their
                need, type, efficiency (aptness), age, etc. A comprehensive curriculum is also formulated to cope up with the existing
                education of the mainstream curriculum.</p>
            </div>
            <div class="col-md-6 mbody-img-margin">
                <img title="education system" src="assets/img/school/Education System.jpg" alt="education system">
            </div>
        </div>
    </div>
</section>